
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transform-data/stack",
      function () {
        return require("private-next-pages/transform-data/stack.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transform-data/stack"])
      });
    }
  